import { render, staticRenderFns } from "./studentMonthAttendance.vue?vue&type=template&id=4c37dbb8&scoped=true&"
import script from "./studentMonthAttendance.vue?vue&type=script&lang=js&"
export * from "./studentMonthAttendance.vue?vue&type=script&lang=js&"
import style0 from "./studentMonthAttendance.vue?vue&type=style&index=0&id=4c37dbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37dbb8",
  null
  
)

export default component.exports